<template>
  <div class="cash-withdrawal">
    <nav-bar
      fixed
      z-index="99"
      title="申请提现"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>

    <!-- Payment method tabs -->
    <div class="payment-methods">
       <!--
      <div
        class="payment-method"
        :class="{ active: currentTab === 0 }"
        @click="swichNav(0, navList[0])"
      >
        <div class="icon-container">
          <i class="iconfont icon-weixin2"></i>
        </div>
        <span>微信</span>
      </div>
      <div
        class="payment-method"
        :class="{ active: currentTab === 1 }"
        @click="swichNav(1, navList[1])"
      >
        <div class="icon-container">
          <i class="iconfont icon-icon34"></i>
        </div>
        <span>支付宝</span>
      </div>
      -->
      <div
        class="payment-method"
        :class="{ active: currentTab === 2 }"
        @click="swichNav(2, navList[2])"
      >
        <div class="icon-container">
          <i class="iconfont icon-qiandai"></i>
        </div>
        <span>银行卡</span>
      </div>
    </div>

    <div class="wrapper">
      <!-- WeChat withdrawal form -->
      <div v-show="currentTab === 0" class="form-container">
        <!--
        <div class="form-item">
          <div class="label">微信号</div>
          <div class="input-container">
            <input placeholder="请输入微信号" v-model="post.weixin" readonly />
          </div>
        </div>
        -->
        <div class="withdrawal-details">
          <div class="detail-item">
            <span class="detail-label">订单金额</span>
            <span class="detail-value">¥{{ moneyAll }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">教练分成</span>
            <span class="detail-value">¥{{ post.money }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">提现个税</span>
            <span class="detail-value">¥{{ serviceFee }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"></span>
            <span class="detail-value">¥{{ moneyUserAll }}</span>
          </div>

        </div>
        <div class="withdrawal-description" v-html="withdrawalInstructions"></div>
        <div class="submit-btn" @click="submitted">确认提现</div>
      </div>

      <!-- Alipay withdrawal form -->
      <div v-show="currentTab === 1" class="form-container">
        <div class="form-item">
          <div class="label">姓名</div>
          <div class="input-container">
            <input placeholder="请输入姓名" v-model="post.name" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">支付宝账号</div>
          <div class="input-container">
            <input placeholder="请输入支付宝账号" v-model="post.alipay_code" />
          </div>
        </div>
        <div class="withdrawal-details">
          <div class="detail-item">
            <span class="detail-label">订单金额</span>
            <span class="detail-value">¥{{ moneyAll }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">教练分成</span>
            <span class="detail-value">¥{{ post.money }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">提现个税</span>
            <span class="detail-value">¥{{ serviceFee }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">实际到账金额</span>
            <span class="detail-value">¥{{ moneyUserAll }}</span>
          </div>
        </div>
        <div class="withdrawal-description" v-html="withdrawalInstructions"></div>
        <div class="submit-btn" @click="submitted">确认提现</div>
      </div>


      <div v-show="currentTab === 2" class="form-container">
        <div class="form-item" @click="showAccountType">
          <div class="label">提现账户</div>
          <div class="input-container dropdown">
            <div class="dropdown-text">{{ accountTypeText }}</div>
            <i class="dropdown-arrow">▼</i>
          </div>
        </div>
        <div class="form-item">
          <div class="label">{{accountName}}</div>
          <div class="input-container">
            <input placeholder="请输入名称" v-model="post.bankName" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">{{accountNum}}</div>
          <div class="input-container">
            <input placeholder="请输入卡号" v-model="post.bankCode" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">银行名称/开户地址</div>
          <div class="input-container">
            <input placeholder="请输入银行名称/开户地址" v-model="post.bankAddress" />
          </div>
        </div>
        <div class="withdrawal-details" v-if="currentTab === 2 && post.accountType === '1'">

            <div class="detail-item">
              <span class="detail-label">订单金额</span>
              <span class="detail-value">¥{{ moneyAll }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">教练分成</span>
              <span class="detail-value">¥{{ post.money }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">实际到账金额</span>
              <span class="detail-value">¥{{ post.money }}</span>
            </div>
        </div>
        <div class="withdrawal-details" v-else>

          <div class="detail-item">
            <span class="detail-label">订单金额</span>
            <span class="detail-value">¥{{ moneyAll }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">教练分成</span>
            <span class="detail-value">¥{{ post.money }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">提现个税</span>
            <span class="detail-value">¥{{ serviceFee }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">实际到账金额</span>
            <span class="detail-value">¥{{ moneyUserAll }}</span>
          </div>
        </div>
        <div class="withdrawal-description" v-html="withdrawalInstructions"></div>
        <div class="submit-btn" @click="submitted">确认提现</div>
      </div>
    </div>

    <!-- 账户类型选择器 -->
    <popup v-model="showAccountTypePicker" position="bottom">
      <picker
        show-toolbar
        :columns="accountTypeColumns"
        @confirm="onConfirmAccountType"
        @cancel="onCancelAccountType"
        title="选择账户类型"
      />
    </popup>

    <!-- 简化后的协议弹窗 -->
    <div class="agreement-popup" v-show="showCustomAgreementPopup">
      <div class="agreement-container">
        <div class="agreement-header">
          <div class="agreement-title">签约协议</div>
          <div class="agreement-close" @click="closeAgreementPopup">×</div>
        </div>
        <div class="agreement-content">
          <img src="@assets/img/PDF1.jpg" />
          <img src="@assets/img/PDF2.jpg" />
          <img src="@assets/img/PDF3.jpg" />
          <img src="@assets/img/PDF4.jpg" />
          <img src="@assets/img/PDF5.jpg" />
          <img src="@assets/img/PDF6.jpg" />
        </div>
        <div class="agreement-footer">
          <div class="agreement-btn cancel" @click="closeAgreementPopup">返回</div>
          <div class="agreement-btn confirm" @click="confirmAgreement">同意并签约</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBank, postCashInfo, getUserInfo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { NavBar, Popup, Picker, Dialog } from "vant";
import axios from "axios"; // Make sure axios is imported
import request from "@utils/request";

export default {
  name: "UserCash",
  components: { NavBar, Popup, Picker, Dialog },
  props: {},
  data: function () {
    return {
      navList: [
        { name: "微信", type: "weixin", icon: "icon-weixin2" },
        { name: "支付宝", type: "alipay", icon: "icon-icon34" },
        { name: "银行卡", type: "bank", icon: "icon-qiandai" },
      ],
      post: {
        extract_type: "bank",
        alipay_code: "",
        money: "",
        name: "",
        bankName: "",
        cardnum: "",
        weixin: "",
        bankCode: "",
        bankAddress: "",
        accountType: "", // 账户类型：初始为空，用户需要选择
      },
      currentTab: 2,
      minPrice: 0,
      banks: [],
      commissionCount: 0,
      userInfo: {}, // 保存用户信息
      showAccountTypePicker: false, // 控制账户类型选择器显示
      accountTypeColumns: [
        { text: '个人账户(需签约)', value: '0' },
        { text: '对公账户(无需签约)', value: '1' },
      ],
      accountName: "持卡人姓名",
      accountNum: "银行卡号",
      accountTypeText: '请选择账户类型', // 初始提示文本
      withdrawalInstructions: "提现到账时间为1-3个工作日，请耐心等待。提现金额需大于或等于最低提现金额，单笔提现金额不能超过10000元。如有疑问，请联系客服。", // 默认的提现说明
      feeRate: 0.065, // 综合税费率，默认0.065（6.5%），会从系统配置动态更新
      serviceFee: 0, // 提现个税
      moneyUserAll: 0, // 实际到账金额
      moneyAll: 0, // 预计到账金额
      showCustomAgreementPopup: false, // 控制自定义协议弹窗显示
    };
  },
  computed: {
    // 获取store中保存的用户签约状态
    isUserSigned() {
      return this.$store.state.app.isSign;
    }
  },
  mounted: function () {
    this.getBank();
    this.getInfo();
    this.getSystemConfig();
    this.checkUserInfo();
    this.post.money = String(this.$route.query.money || "");// 从路由参数获取分佣金额
    this.moneyAll = String(this.$route.query.moneyAll || ""); // 预计订单总金额
    this.calculateFee();

    // 进入页面时检查签约状态
    // this.$nextTick(() => {
    //   this.checkSignStatus();
    // });
  },
  methods: {
    getInfo: function () {
      getUserInfo().then((res) => {
        console.log(123456, res);
        this.userInfo = res.data; // 保存完整的用户信息
        this.post.weixin = res.data.wechatNumber;// 微信号
        this.post.alipay_code = res.data.zfbNumber;
        this.post.name = res.data.zfbName;
        this.post.bankName = res.data.holdCardName;
        this.post.bankAddress = res.data.bankName;
        this.post.bankCode = res.data.bankNumber;
      });
    },
    swichNav: function (index, item) {
      // 检查是否需要签约
      if (item.type !== 'bank' || (item.type === 'bank' && this.post.accountType === '0')) {
        // 微信、支付宝或个人银行卡账户需要检查签约状态
        if (this.$store.state.app.isSign != 1) {
          this.showSigningAlert();
          return;
        }
      }

      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    getBank: function () {
      let that = this;
      getBank().then(
        (res) => {
          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.commissionCount = res.data.commissionCount;
        },
        function (err) {
          Dialog.alert({
            message: err.msg || "获取银行信息失败"
          });
        }
      );
    },
    async submitted() {
      console.log('提现按钮被点击');

      let alipay_code = this.post.alipay_code,
        money = this.post.money,
        name = this.post.name,
        weixin = this.post.weixin,
        bankName = this.post.bankName,
        bankCode = this.post.bankCode,
        bankAddress = this.post.bankAddress,
        that = this;

      console.log('当前提现类型:', that.post.extract_type);
      console.log('提现表单数据:', {
        money,
        weixin,
        alipay_code,
        name,
        bankName,
        bankCode,
        bankAddress
      });

      // 检查提现金额
      if (!money) {
        Dialog.alert({
          message: "请输入提现金额"
        });
        return;
      }

      // 检查是否已选择账户类型
      if (!that.post.accountType) {
        Dialog.alert({
          message: "请选择提现账户类型"
        });
        return;
      }

      if (
        parseFloat(money) > parseFloat(that.commissionCount) ||
        parseFloat(that.commissionCount) == 0
      ) {
        Dialog.alert({
          message: "实际提现金额大于和可提现金额，请与平台工作人员联系排查问题"
        });
        return;
      }

      // 获取当前签约状态
      const currentSignStatus = this.$store.state.app.isSign;
      console.log('当前签约状态:', currentSignStatus);

      // 银行卡公户提现不需要签约检查
      const accountTypeNum = parseInt(that.post.accountType);
      const isPublicAccount = that.post.extract_type === 'bank' && accountTypeNum === 1;

      // 打印更详细的调试信息
      console.log('提现类型:', that.post.extract_type);
      console.log('账户类型原始值:', that.post.accountType);
      console.log('账户类型转换后:', accountTypeNum);
      console.log('是否公户:', isPublicAccount);

      // 如果是公户提现，无需签约状态检查
      if (isPublicAccount) {
        console.log('公户提现，无需签约状态检查');
        // 直接处理提现逻辑
        this.handleBankWithdraw(true);
        return;
      }

      // 非公户提现，检查签约状态
      if (currentSignStatus != 1) {
        console.log('用户未签约(isSign!=1)，显示签约提示');
        this.showSigningAlert();
        return; // 阻止继续执行提现流程
      }

      // 已签约用户，根据提现类型处理不同的提现方式
      console.log('用户已签约，处理提现请求');
      switch (that.post.extract_type) {
        case 'weixin':
          this.handleWechatWithdraw();
          break;
        case 'alipay':
          this.handleAlipayWithdraw();
          break;
        case 'bank':
          this.handleBankWithdraw(false);
          break;
      }
    },

    // 微信提现处理
    handleWechatWithdraw() {
      let weixin = this.post.weixin,
        money = this.post.money,
        that = this;

      // 检查微信提现必填项
      // if (!weixin) {
      //   Dialog.alert({
      //     message: "请输入微信号"
      //   });
      //   return;
      // }
      if (!money) {
        Dialog.alert({
          message: "请输入提现金额"
        });
        return;
      }

      try {
        this.$validator({
          weixin: [required(required.message("提现微信号"))],
          money: [required(required.message("提现金额"))],
        }).validate({ weixin, money });

        // 转换订单ID为整数数组
        const orderIds = that.$route.query.orderList
          ? that.$route.query.orderList.split(",").map(id => parseInt(id))
          : [];

        let withdrawData = {
          accountType: 0,
          extractType: "weixin",
          weixin: weixin,
          money: money,
          userType: 0,
          channelId: 0,
          orderIds: orderIds,
          alipayCode: "",
          name: "",
          bankName: "",
          bankCode: "",
          bankAddress: "",
          realName: that.userInfo.realName || "",
        };
        that.submitWithdrawal(withdrawData);
      } catch (e) {
        return validatorDefaultCatch(e);
      }
    },

    // 支付宝提现处理
    handleAlipayWithdraw() {
      let alipay_code = this.post.alipay_code,
        name = this.post.name,
        money = this.post.money,
        that = this;

      // 检查支付宝提现必填项
      if (!name) {
        Dialog.alert({
          message: "请输入姓名"
        });
        return;
      }
      if (!alipay_code) {
        Dialog.alert({
          message: "请输入支付宝账号"
        });
        return;
      }
      if (!money) {
        Dialog.alert({
          message: "请输入提现金额"
        });
        return;
      }

      try {
        this.$validator({
          name: [required(required.message("支付宝用户名"))],
          alipay_code: [required(required.message("支付宝账号"))],
          money: [required(required.message("提现金额"))],
        }).validate({ name, alipay_code, money });

        // 转换订单ID为整数数组
        const orderIds = that.$route.query.orderList
          ? that.$route.query.orderList.split(",").map(id => parseInt(id))
          : [];

        let withdrawData = {
          accountType: 0,
          extractType: "alipay",
          alipayCode: name,
          name: alipay_code,
          money: money,
          userType: 0,
          channelId: 0,
          orderIds: orderIds,
          weixin: "",
          bankName: "",
          bankCode: "",
          bankAddress: "",
          realName: that.userInfo.realName || "",
        };
        that.submitWithdrawal(withdrawData);
      } catch (e) {
        return validatorDefaultCatch(e);
      }
    },

    // 银行卡提现处理
    handleBankWithdraw(isPublicAccount) {
      let bankName = this.post.bankName,
        bankCode = this.post.bankCode,
        bankAddress = this.post.bankAddress,
        money = this.post.money,
        that = this;

      // 检查银行卡提现必填项
      if (!bankName) {
        Dialog.alert({
          message: "请输入持卡人姓名"
        });
        return;
      }
      if (!bankCode) {
        Dialog.alert({
          message: "请输入银行卡号"
        });
        return;
      }
      if (!bankAddress) {
        Dialog.alert({
          message: "请输入银行名称/开户地址"
        });
        return;
      }
      if (!money) {
        Dialog.alert({
          message: "请输入提现金额"
        });
        return;
      }

      try {
        this.$validator({
          bankName: [required(required.message("持卡人姓名"))],
          bankCode: [required(required.message("银行卡号"))],
          bankAddress: [required(required.message("银行名称/开户地址"))],
          money: [required(required.message("提现金额"))],
        }).validate({ bankName, bankCode, bankAddress, money });

        // 转换账户类型为数字确保一致性
        const accountType = parseInt(that.post.accountType);
        console.log('提交前最终账户类型:', accountType);

        // 转换订单ID为整数数组
        const orderIds = that.$route.query.orderList
          ? that.$route.query.orderList.split(",").map(id => parseInt(id))
          : [];

        let withdrawData = {
          accountType: accountType,
          extractType: "bank",
          bankName: bankName,
          bankCode: bankCode,
          bankAddress: bankAddress,
          realName: that.userInfo.realName || "",
          money: money,
          userType: 0,
          channelId: 0,
          orderIds: orderIds,
          alipayCode: "",
          name: "",
          weixin: "",
        };

        // 如果是公户提现，使用特殊的提交方法
        if (isPublicAccount) {
          that.submitPublicAccountWithdrawal(withdrawData);
        } else {
          that.submitWithdrawal(withdrawData);
        }
      } catch (e) {
        return validatorDefaultCatch(e);
      }
    },

    // 常规提现请求提交（需已签约）
    submitWithdrawal(data) {
      console.log('提交常规提现请求:', data);
      postCashInfo(data).then(
        (res) => {
          if (res.status === 200) {
            // 提现成功
            Dialog.alert({
              title: '提现成功',
              message: res.msg || "恭喜您已完成线上提现",
            }).then(() => {
              // 关闭当前页面，返回上一级
              this.$router.go(-1);
            });
          } else {
            // 提现失败
            Dialog.alert({
              title: '提现失败',
              message: res.msg || "提现失败，请稍后重试"
            });
          }
        },
        (error) => {
          // 请求错误
          Dialog.alert({
            title: '提现失败',
            message: error.msg || "网络异常，请稍后重试"
          });
        }
      );
    },

    // 公户提现请求提交（无需签约）
    submitPublicAccountWithdrawal(data) {
      console.log('提交公户提现请求:', data);

      // 获取当前签约状态（用于恢复）
      const originalSignStatus = this.$store.state.app.isSign;

      // 临时设置签约状态为已签约
      if (originalSignStatus !== 1) {
        console.log('临时修改签约状态为已签约(1)');
        this.$store.commit("SET_IS_SIGN", 1);
      }

      postCashInfo(data).then(
        (res) => {
          // 恢复原始签约状态
          if (originalSignStatus !== 1) {
            console.log('恢复原始签约状态:', originalSignStatus);
            this.$store.commit("SET_IS_SIGN", originalSignStatus);
          }

          if (res.status === 200) {
            // 提现成功
            Dialog.alert({
              title: '提现成功',
              message: res.msg || "恭喜您已完成线上提现",
            }).then(() => {
              // 关闭当前页面，返回上一级
              this.$router.go(-1);
            });
          } else {
            // 提现失败
            Dialog.alert({
              title: '提现失败',
              message: res.msg || "提现失败，请稍后重试"
            });
          }
        },
        (error) => {
          // 恢复原始签约状态
          if (originalSignStatus !== 1) {
            console.log('恢复原始签约状态:', originalSignStatus);
            this.$store.commit("SET_IS_SIGN", originalSignStatus);
          }

          // 请求错误
          Dialog.alert({
            title: '提现失败',
            message: error.msg || "网络异常，请稍后重试"
          });
        }
      );
    },
    // 显示账户类型选择器
    showAccountType() {
      this.showAccountTypePicker = true;
    },
    // 取消账户类型选择
    onCancelAccountType() {
      this.showAccountTypePicker = false;
    },
    // 确认账户类型选择
    onConfirmAccountType(value) {
      // 如果选择个人账户，检查签约状态
      if (value.value === '0' && this.$store.state.app.isSign != 1) {
        this.showSigningAlert();
        // 仍然更新UI，但不进行实际提现操作
      }

      if (value.value === '0'){
        this.accountName = "持卡人姓名";
        this.accountNum = "银行卡号";
      } else {
        this.accountName = "公司名称";
        this.accountNum = "公户卡号";
      }

      this.post.accountType = value.value;
      this.accountTypeText = value.text;
      this.showAccountTypePicker = false;
    },
    // 新增通用签约检查提示函数
    showSigningAlert() {
      Dialog.confirm({
        title: '提示',
        message: '您当前没签约，无法进行提现',
        confirmButtonText: '去签约',
        cancelButtonText: '取消',
        confirmButtonColor: '#0ce6df',
        className: 'custom-dialog'
      }).then(() => {
        // 用户点击去签约，先预览协议文档
        this.previewAgreement();
      }).catch(() => {
        // 用户取消签约
        console.log('用户取消签约');
      });
    },
    // 修改：预览协议文档，使用自定义弹窗
    previewAgreement() {
      // 显示自定义协议弹窗
      this.showCustomAgreementPopup = true;
    },

    // 关闭协议弹窗
    closeAgreementPopup() {
      this.showCustomAgreementPopup = false;
    },

    // 确认协议并跳转到签约页面
    confirmAgreement() {
      this.showCustomAgreementPopup = false;
      this.$router.push({
        path: "/user/signing",
      });
    },

    // 新增：进入页面时检查签约状态
    checkSignStatus() {
      // 获取当前签约状态
      const isUserSigned = this.$store.state.app.isSign;
      console.log('检查签约状态:', isUserSigned);

      // 如果用户未签约，显示签约提示
      if (isUserSigned != 1) {
        this.showSigningAlert();
      }
    },
    // 计算提现个税与实际到账金额
    calculateFee: function() {
      const money = parseFloat(this.post.money) || 0;
      const rate = typeof this.feeRate === 'number' && !isNaN(this.feeRate) ? this.feeRate : 0.065;
      this.serviceFee = (money * rate).toFixed(2);
      this.moneyUserAll = (money - this.serviceFee).toFixed(2);
    },
    // 获取系统配置
    getSystemConfig: function() {
      // 使用项目中已配置的request模块发送请求
      request.get("/api/lcSystemConfig", {
        size: 1000
      }).then(data => {
        console.log("系统配置数据:", data);
        // API返回的结构是 {data: {content: [...]} }
        if (data && data.data && data.data.content) {
          // 查找id为280的配置项（提现说明）
          const config = data.data.content.find(item => item.id === 280);
          if (config) {
            console.log("找到提现说明配置:", config);
            this.withdrawalInstructions = config.value;
          } else {
            console.log("未找到id为280的配置项");
          }

          // 查找提现税费率配置项 bi_an_fee_rate
          const feeRateConfig = data.data.content.find(
            item => item.menuName === "bi_an_fee_rate" || item.name === "bi_an_fee_rate"
          );
          if (feeRateConfig && feeRateConfig.value) {
            const parsedRate = parseFloat(feeRateConfig.value);
            if (!isNaN(parsedRate)) {
              this.feeRate = parsedRate;
              this.calculateFee();
              console.log("动态加载提现综合税费率:", this.feeRate);
            }
          }
        }
      }).catch(error => {
        console.error('获取系统配置失败', error);
        // 发生错误时使用默认提现说明
      });
    },
    checkUserInfo: function() {
      getUserInfo().then(res => {
        console.log('获取用户信息成功:', res.data);
        this.$store.commit("SET_USER", res.data);

        // 检查用户是否已签约，保存签约状态到 store
        if (res.data.isSign !== undefined) {
          this.$store.commit("SET_IS_SIGN", res.data.isSign);
          console.log('用户签约状态:', res.data.isSign);
        }
      }).catch(err => {
        console.error("获取用户信息失败:", err);
        Dialog.alert({
          message: err.msg || "获取用户信息失败"
        });
      });
    },
  },
};
</script>

<style scoped>
.cash-withdrawal {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 20px;
}

/* Payment method tabs styling */
.payment-methods {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 15px 0;
  margin: 15px 15px 20px;
  border-radius: 10px;
}

.payment-method {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin: 0px 10px 0px 10px;
  position: relative;
  border-radius: 10px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}

.payment-method .iconfont {
  font-size: 28px;
  color: #666;
}

.payment-method.active {
  background-color: rgba(12, 230, 223, 0.1);
}

.payment-method.active .iconfont {
  color: #0ce6df;
}

/* Form styling */
.form-container {
  background-color: #fff;
  margin: 0 15px;
  border-radius: 10px;
  padding: 1px;
}

.withdrawal-details {
  padding: 15px;
  background-color: #fff;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #666;
  font-size: 14px;
}

.detail-value {
  color: #333;
  font-size: 16px;
  font-weight: 500;
}

.withdrawal-description {
  padding: 15px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  border-bottom: none;
}

.form-item {
  padding: 15px;
  border-bottom: 1px solid #f5f5f5;
}

.label {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.input-container {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 5px;
  padding: 10px;
}

.input-container input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
  width: 100%;
}

.dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-text {
  color: #333;
  font-size: 16px;
}

.dropdown-arrow {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
}

.submit-btn {
  margin: 30px 15px;
  background-color: #0ce6df;
  color: white;
  padding: 15px;
  text-align: center;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 500;
}

.wrapper {
  margin-bottom: 20px;
}

/* 协议弹窗样式 */
.agreement-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.agreement-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.agreement-header {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
}

.agreement-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.agreement-close {
  position: absolute;
  right: 15px;
  top: 0;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  width: 50px;
  cursor: pointer;
}

.agreement-content {
  flex: 1;
  overflow-y: auto;
  padding: 2px;
  background-color: #f5f5f5;
}

.agreement-content img {
  width: calc(100% - 4px);
  display: block;
  margin: 0 0 2px 0;
}

.agreement-footer {
  height: 60px;
  display: flex;
  border-top: 1px solid #f5f5f5;
}

.agreement-btn {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.cancel {
  color: #666;
  background-color: #f5f5f5;
}

.confirm {
  color: #fff;
  background-color: #0ce6df;
}
</style>
